module.exports = __webpack_public_path__ + "static/img/about_p1_2x.25e10d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_p1_2x.png
// module id = 2u3W
// module chunks = 1